import React, { useState, useCallback, useRef, useEffect } from 'react';

import DataGrid, { Selection, RowDragging, Column, Editing, Scrolling, Paging, Toolbar, Item, MasterDetail, Export, Summary, TotalItem } from 'devextreme-react/data-grid';
import DropDownButton, { DropDownButtonTypes } from 'devextreme-react/drop-down-button';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import TextBox from 'devextreme-react/text-box';
import './CardResultsRelay.scss';

import { checkPermission } from '../../../permissions';
import { EditCellTimeComponent, EditCellTimeRender, editCellTimeRender, TimeBox, TimeBoxBold } from '../../utils/time-box/TimeBox';
import { Button, NumberBox } from 'devextreme-react';
import { PerformanceCell } from '../../utils/performance-cell/PerformanceCell';
import { useScreenSize } from '../../../utils/media-query';
import { COMPETITION_STATUS_LIST, exportFormats } from '../../../shared/constants';
import { ResultRelayDetails } from '../result-relay-details/ResultRelayDetails';
import { onExporting } from '../../../utils/exporter';
import { useNavigate } from 'react-router-dom';
import { FALSE } from 'sass';
import { getApiToken } from '../../../utils/authUtils.js';
import axios from 'axios';



const Grid = ({ results, competitionId, traininggroups }) => {
    const [gridData, setGridData] = useState(results);

    const dropDownOptions = { width: 'auto' };
    const handleInitNewRow = (e) => {
        e.data.competitionId = competitionId;
    };
    const gridRef = useRef(null);

    const navigate = useNavigate();




    return (
        <DataGrid
            className='results-grid'
            dataSource={gridData}
            remoteOperations={true}
            width={'100%'}
            height={'calc(100vh - 250px)'}
            onInitNewRow={handleInitNewRow}
            rowAlternationEnabled={true}
            onExporting={onExporting}
            ref={gridRef}
            filterRow={{ visible: true, applyFilter: 'auto' }}
        //  columnAutoWidth={useScreenSize() === 'xs'}
        >
          
            <Paging enabled={false} />
            <MasterDetail
                enabled={true}
                component={ResultRelayDetails}
            />

            <Scrolling mode='virtual' />
            <Editing allowUpdating={checkPermission("result.edit")} allowAdding={false} allowDeleting={checkPermission("result.edit")} />

            <Column
                groupIndex={competitionId === undefined ? undefined : 0}
                dataField='clubname'
                caption='Verein'
                width={0}
                allowEditing={false}
            />

            <Column
                visible={competitionId === undefined ? true : false}
                dataField='startdate'
                caption='Datum'
                dataType='date'
                width={100}
                sortIndex={competitionId === undefined ? 0 : undefined}
                sortOrder={competitionId === undefined ? 'desc' : undefined}
                allowEditing={false}
            />
            <Column
                visible={competitionId === undefined ? true : false}
                dataField='competitionname'
                caption='Wettkampf'
                width={200}
                allowEditing={false}

            />
            <Column
                dataField='eventorder'
                visible={false}
                sortIndex={competitionId === undefined ? undefined : 0}
                sortOrder={competitionId === undefined ? undefined : 'asc'}
                allowEditing={false}
            />
            <Column
                dataField='number'
                caption='WettkampfNr'
                width={50}
                hidingPriority={5}
                visible={competitionId === undefined ? false : true}
                allowEditing={false}
            />
            <Column
                dataField='name'
                caption='Strecke'
                width={80}
                hidePriority={7}
                allowEditing={false}
            />
            <Column
                dataField='swimtime'
                caption='Zeit'
                dataType='number'
                width={80}
                cellRender={TimeBoxBold}
                editCellComponent={EditCellTimeComponent}
                hidingPriority={6}
            />
            <Column
                dataField='waPoints'
                caption='WA-Punkte'
                width={80}
                hidingPriority={1}

            />
            <Column
                dataField='details'
                caption='Detail'
                wordWrapEnabled={true}
                width={80}
                hidingPriority={0}
            />

        </DataGrid>
    );
};

const GridWithLoadPanel = withLoadPanel(Grid);

export const CardResultsRelay = ({ results, isLoading, competitionId, traininggroups }) => {
    return (
        <div className='card-results-relay'>
            <GridWithLoadPanel
                results={results}
                hasData={!!results}
                loading={isLoading}
                competitionId={competitionId}
                traininggroups={traininggroups}
                panelProps={{
                    container: '.card-results-relay',
                    position: { of: '.card-results-relay' }
                }}
            />
        </div>
    );
};

